import React from 'react';
import styles from './Banner2.module.css';

import Cans2 from '../cans2/Cans2';

import orangecan from '../../assets/orange-can.png';
import orangefruit1 from '../../assets/orange-fruit-1.png';
import orangefruit2 from '../../assets/orange-fruit-2.png';

import purplecan from '../../assets/purple-can.png';
import purplefruit1 from '../../assets/purple-fruit-1.png';
import purplefruit2 from '../../assets/purple-fruit-2.png';

import yellowcan from '../../assets/yellow-can.png';
import yellowfruit1 from '../../assets/yellow-fruit-1.png';
import yellowfruit2 from '../../assets/yellow-fruit-2.png';

import redcan from '../../assets/red-can.png';
import redfruit1 from '../../assets/red-fruit-1.png';
import redfruit2 from '../../assets/red-fruit-2.png';
const Banner2 = () => {
    return(
        <div id="home" className={styles.parent}>
            <h4>Real Fruit. Unique Flavours. Vitamin C Enriched</h4>
            {/* <h2>Crafted from Real Fruit.<br /> Enriched with Vitamin C</h2> */}
            <div className={styles.banner_bottom}>
                <Cans2 can={redcan} fruit1={redfruit1} fruit2={redfruit2} inner={{background: "#EA7D1A"}} outer={{background: "#EA7D1A"}} />
                <Cans2 can={yellowcan} fruit1={yellowfruit1} fruit2={yellowfruit2} inner={{background: "#A954DD"}} outer={{background: "#A954DD"}} />
                <Cans2 can={purplecan} fruit1={purplefruit1} fruit2={purplefruit2} inner={{background: "#F2CB49"}} outer={{background: "#F2CB49"}} />
                <Cans2 can={orangecan} fruit1={orangefruit1} fruit2={orangefruit2} inner={{background: "#DB1A1D"}} outer={{background: "#DB1A1D"}} />
            </div>
        </div>
    )
}

export default Banner2;